/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ThemedStyleFn, useStyles } from '~src/hooks/useStyles';

interface ExpandCollapseIconProps {
  isExpanded: boolean;
  onClick: () => void;
  hasChildren: boolean;
}

export const ExpandCollapseIcon: React.FC<ExpandCollapseIconProps> = ({
  isExpanded,
  onClick,
  hasChildren,
}) => {
  const styles = useStyles(styleFn);

  if (!hasChildren) {
    return null;
  }

  return (
    <div
      css={styles.iconContainer}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}>
      <FontAwesomeIcon
        icon={['fas', isExpanded ? 'chevron-down' : 'chevron-right']}
        css={styles.icon}
      />
    </div>
  );
};

const styleFn: ThemedStyleFn = (theme) => ({
  iconContainer: {
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    borderRadius: 4,
    transition: 'all 0.2s ease',
    flexShrink: 0,
    '&:hover': {
      backgroundColor: theme.colors.primaryLight || 'rgba(24, 144, 255, 0.1)',
    },
  },
  icon: {
    fontSize: 12,
    color: theme.colors.textSecondary,
    transition: 'transform 0.2s ease',
  },
});
